import { render, staticRenderFns } from "./PackProductDialog.vue?vue&type=template&id=d061dda4"
import script from "./PackProductDialog.vue?vue&type=script&lang=js"
export * from "./PackProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports